/*
NOTE: This file contains custom 3rd JavaScript code to enhance the accessibility of the website.
The code does not meet our usual quality standards but is necessary for accessibility compliance.
It may be updated or removed in future releases as we improve our codebase.
*/

// Drop down menu accessibility script
document.addEventListener('DOMContentLoaded', () => {
  const navContent = document.querySelector('.nav__content');
  let lastTriggerButton = null;

  const getSubnavByButton = (btn) =>
    document.getElementById(btn.getAttribute('data-target'));

  const closeMenu = () => {
    if (!navContent) return;

    // Hide any open subnavs
    navContent.querySelectorAll('[aria-hidden="false"]').forEach(el => {
      el.setAttribute('aria-hidden', 'true');
    });

    // Update buttons
    navContent.querySelectorAll('.js-navSubnavButton').forEach(btn => {
      btn.setAttribute('aria-expanded', 'false');
    });

    // Remove "open" state on the container if present
    navContent.classList.remove('nav__content--open');

    // Return focus to the button that opened the menu
    if (lastTriggerButton) {
      lastTriggerButton.focus({ preventScroll: true });
    }
  };

  // Keep aria-expanded in sync + remember which button opened the visible subnav
  const updateAriaExpanded = () => {
    if (!navContent) return;
    const navIsOpen = navContent.classList.contains('nav__content--open');

    navContent.querySelectorAll('.js-navSubnavButton').forEach(button => {
      const subnav = getSubnavByButton(button);
      const subnavVisible = subnav && subnav.getAttribute('aria-hidden') === 'false';
      const expanded = (navIsOpen && subnavVisible) ? 'true' : 'false';

      button.setAttribute('aria-expanded', expanded);

      // Track the current trigger if its subnav is visible
      if (expanded === 'true') lastTriggerButton = button;
    });
  };

  // Initial check
  updateAriaExpanded();

  // Observe changes in nav content
  const observer = new MutationObserver(updateAriaExpanded);
  if (navContent) {
    observer.observe(navContent, {
      attributes: true,
      subtree: true,
      attributeFilter: ['class', 'aria-hidden']
    });
  }

  // ESC closes menu and returns focus to opener
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      const isAnyOpen =
        navContent?.classList.contains('nav__content--open') ||
        navContent?.querySelector('[aria-hidden="false"]');
      if (isAnyOpen) {
        e.preventDefault();
        closeMenu();
      }
    }
  }, true);

  if (navContent) {
    // If subnavs are opened by clicking/pressing on buttons, record the trigger
    navContent.querySelectorAll('.js-navSubnavButton').forEach(btn => {
      btn.addEventListener('click', () => { lastTriggerButton = btn; }, { capture: true });
      btn.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') lastTriggerButton = btn;
      });
    });
  }
});

// Basic Accessibility Enhancements
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('br').forEach(element => {
      element.setAttribute('aria-hidden', 'true');
    });
    document.querySelectorAll('.header__top-hat.js-topHat p').forEach(element => {
      element.setAttribute('aria-hidden', 'true');
    });
    document.querySelectorAll('.swiper-wrapper').forEach(element => {
      element.setAttribute('role', 'list');
    });
    document.querySelectorAll('.swiper-slide').forEach(element => {
      element.setAttribute('role', 'listitem');
    });
    document.querySelectorAll('.content-module__text__cta a').forEach(link => {
      link.setAttribute('aria-label', 'Shop now, handcrafted products by PORTA in collaboration with artisans.');
    });
    document.querySelectorAll('a[href="/collections/all-products"]').forEach(link => {
      link.setAttribute('aria-label', 'View All Products');
    });
  });

// adding warning to collection filters
document.addEventListener('DOMContentLoaded', () => {
  const buttonSort = document.querySelector('button#collection-sort-toggle');

  if (buttonSort) {
    const trimmedText = buttonSort.textContent.trim();
    buttonSort.setAttribute('aria-label', `${trimmedText}, the page will refresh when you select an option.`);
  }

  const buttonFilter = document.querySelector('button#collection-filter-toggle');

  if (buttonFilter) {
    const trimmedText = buttonFilter.textContent.trim();
    buttonFilter.setAttribute('aria-label', `${trimmedText}, the page will refresh when you select an option.`);
  }

  // External Links Warning
  const handleExternalLinks = () => {
    const links = document.querySelectorAll('a');

    const isThirdParty = (url) => {
      try {
        const linkHost = new URL(url).hostname;
        const currentHost = window.location.hostname;
        return linkHost && linkHost !== currentHost;
      } catch (e) {
        return false;
      }
    };

    links.forEach(link => {
      const href = link.getAttribute('href');
      if (!href || !isThirdParty(href)) return;

      // Open in new tab
      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener noreferrer');

      // Set aria-label
      const existingText = link.textContent.trim();
      const ariaLabel = `${existingText}, This link will open in a new tab`;
      link.setAttribute('aria-label', ariaLabel);

      // Update image alt text
      const img = link.querySelector('img, svg');
      if (img) {
        let altText = img.getAttribute('alt') || '';
        const updatedAlt = altText
          ? `${altText}, This link will open in a new tab`
          : 'This link will open in a new tab';
        img.setAttribute('alt', updatedAlt);
      }
    });
  };

  handleExternalLinks();

  // Email and phone number labels
  const handleContactLinks = () => {
    const links = document.querySelectorAll('a[href^="mailto:"], a[href^="tel:"]');

    links.forEach(link => {
      const href = link.getAttribute('href');
      const linkText = link.textContent.trim();

      if (href.startsWith('mailto:')) {
        link.setAttribute('aria-label', `Email Address: ${linkText}`);
      } else if (href.startsWith('tel:')) {
        link.setAttribute('aria-label', `Phone number: ${linkText}`);
      }
    });
  };

  handleContactLinks();

  document.querySelectorAll("h2.about__text__title, h1").forEach(el => {
    if (!el.textContent.trim()) el.remove();
  });

  // Add to cart success message
  const liveRegion = document.getElementById("cart-status");

  function announce(message) {
    if (!liveRegion) return;

    // Clear message first
    liveRegion.textContent = "";

    // Set message
    setTimeout(() => {
      liveRegion.textContent = message;

      // Remove message after 1 second
      setTimeout(() => {
        liveRegion.textContent = "";
      }, 1000);
    }, 50);
  }

  // TODO: refactor --> combine with add to cart listener
  document.addEventListener("click", (e) => {
    const button = e.target.closest(".product-content__add.js-productInfoAdd");
    if (!button) return;

    let productName = button.dataset.productName || "";

    if (!productName) {
      const titleEl = button
        .closest("[data-product]")
        ?.querySelector(".product-title, .product__title, h1, h2");
      if (titleEl) productName = titleEl.textContent.trim();
    }

    if (!productName) productName = "Product";

    announce(`${productName} added to cart`);
  });
});
